// @ts-ignore
import VistaprintAuth from "@vp/auth";
import { ProductConfiguration } from "@vp/hamilton-service-clients/dist/src/types/Pricing";
import axios from "axios";
import qs from "qs";
import { Logger } from "../logging/logger";
import { RanchResponse } from "../types/RanchTypes";
import PageConfig from "../utils/PageConfig";

const BASE_URL = "https://ranch-cdn.products.cimpress.io/api/v1";

const callRanchService = async (props: {
  productId: string;
  version: number;
  market: string;
  selectedOptions: Record<string, string>;
}): Promise<RanchResponse | undefined> => {
  const { productId, version, market, selectedOptions } = props;
  const authLibrary = new VistaprintAuth.WebAuth();
  const authorizationHeader = authLibrary.getAuthorizationHeader();

  const queryParams = {
    context: {
      Market: market,
      Merchant: PageConfig.tenant,
    },
    options: selectedOptions,
    requestor: PageConfig.requestor,
  };

  const url = `${BASE_URL}/Products/${productId}/versions/${version}:complete?${qs.stringify(
    queryParams
  )}`;

  if (authorizationHeader) {
    try {
      const response = await axios.get(url, {
        headers: { Authorization: authorizationHeader },
      });
      if (response.data) {
        return response.data;
      }
    } catch (e) {
      const error = e as Error & { response?: { status?: number } };
      const status = error && error.response && error.response.status;
      if (status !== 400) {
        Logger.instance.error("RANCH failed to get fully configured product", {
          errorMessage: error.message,
          url,
          status,
        });
      } else {
        Logger.instance.warning("RANCH failed to get fully configured product", {
          errorMessage: error.message,
          url,
          status,
        });
      }
    }
  }

  return undefined;
};

export const getProductCompletion = async (props: {
  productId: string;
  version: number;
  market: string;
  selectedOptions: Record<string, string>;
}): Promise<ProductConfiguration | undefined> => {
  const ranchResponse = await callRanchService(props);

  if (ranchResponse && ranchResponse.configurations && ranchResponse.configurations.length > 0) {
    const usableConfiguration = ranchResponse.configurations[0];
    const productConfiguration: ProductConfiguration = {};
    usableConfiguration.options.forEach(option => {
      productConfiguration[option.name] = option.value;
    });

    return productConfiguration;
  }

  return undefined;
};
